import enUS from './locales/en-us.yaml'
import deDE from './locales/de-de.yaml'

// import editorDE from 'ui-common/base/i18n/locales/de-de.yaml'

export default {
  'en-us': enUS,
  'de-de': deDE // { ...deDE, editorHelper: editorDE.editorHelper }
}
